import React from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControlLabel,
  Radio,
  RadioGroup,
  Typography,
  Box,
} from "@mui/material";

const choices = [
  {
    value: "reset",
    label: "Reset Client Approval",
    description: "The regenerated Sales Order will return to Agreement Pending and must be approved again. Existing payments and proof approvals will remain unchanged.",
  },
  {
    value: "preserve",
    label: "Keep Client Approved",
    description: "The regenerated Sales Order will remain Client Approved. Use this only for internal corrections or changes that do not require customer approval.",
  },
];

export default function ApprovalRegenerationDialog({ open, value, onChange, onCancel, onConfirm, submitting }) {
  return (
    <Dialog open={open} onClose={submitting ? undefined : onCancel} fullWidth maxWidth="sm">
      <DialogTitle>Regenerate Approved Sales Order</DialogTitle>
      <DialogContent>
        <Typography sx={{ mb: 2 }}>
          This Sales Order is currently Client Approved. Choose how regeneration should affect the customer’s approval.
        </Typography>
        <RadioGroup value={value} onChange={(event) => onChange(event.target.value)}>
          {choices.map((choice) => (
            <Box key={choice.value} sx={{ border: "1px solid", borderColor: "divider", borderRadius: 2, p: 1.5, mb: 1 }}>
              <FormControlLabel value={choice.value} control={<Radio />} label={choice.label} disabled={submitting} />
              <Typography variant="body2" color="text.secondary" sx={{ ml: 4 }}>
                {choice.description}
              </Typography>
            </Box>
          ))}
        </RadioGroup>
      </DialogContent>
      <DialogActions>
        <Button onClick={onCancel} disabled={submitting}>Cancel</Button>
        <Button variant="contained" onClick={onConfirm} disabled={submitting || !value}>
          {submitting ? "Regenerating…" : "Regenerate Sales Order"}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
